import React from "react";
import PropTypes from "prop-types";

function Back({ className, style, fill, defaultWidth, defaultHeight }) {
  return (
    <svg
      viewBox="0 0 14 9"
      width={style && style.width ? style.width : defaultWidth}
      height={style && style.width ? style.height : defaultHeight}
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M.990984 6.50198L7.120266.242812c.244546-.253605.639984-.253605.88453 0l.369423.383104c.244547.253604.244547.663687 0 .917291L3.051422 6.960625l5.317594 5.417417c.244546.253604.244546.663687 0 .917291l-.369422.383105c-.244547.253604-.639985.253604-.884532 0L.985782 7.41927c-.239345-.253604-.239345-.663688.005202-.917292z"
        fill={fill}
        fillRule="nonzero"
      />
    </svg>
  );
}

Back.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  fill: PropTypes.string
};

Back.defaultProps = {
  className: undefined,
  defaultHeight: 9,
  defaultWidth: 14,
  fill: "#D2E3E4"
};

export default Back;
